import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, MonedaService, ComunidadService, ExpensaService, EstadoService, ConsorcioService } from '../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, Moneda, SearchExpensaRequestDto, Comunidad, SearchMonedaRequest, LocalStorageKeys, Consorcio, SearchConsorcioRequest } from '../../../../src/app/shared/model';
import { ExportMediaTypeConstants, SearchComunidadRequest, ExpensaDto, Estado, SearchEstadoRequest, EstadoConstants } from '../../../../src/app/shared/model';

@Component({
  selector: 'app-expensaLista',
  templateUrl: './expensaLista.component.html',
  styles: [ ]
})

export class ExpensaListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  comunidadList: Comunidad[];
  consorcioList: Consorcio[];
  monedaList: Moneda[];
  estadoList: Estado[];

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  isMonedaSearching: boolean = false;
  isConsorcioSearching: boolean = false;
  isComunidadSearching: boolean = false;
  isEstadoSearching: boolean = false;

  canEdit: boolean = false;
  canView: boolean = false;
  canConfig: boolean = false;
  esUsuarioFinal: boolean = false;

  public query: Query;

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private monedaService: MonedaService,
    private consorcioService: ConsorcioService,
    private comunidadService: ComunidadService,
    private estadoService: EstadoService,
    private service: ExpensaService,
    private datePipe: DatePipe) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.EXPENSA).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result && data?.Result.length > 0) {
        this.canEdit = data.Result.some(x => x == MenuFuncionCodes.EXPENSA_LIQUIDACION);
        this.canConfig = data.Result.some(x => x == MenuFuncionCodes.EXPENSA_CONFIG);

        this.esUsuarioFinal = this.sharedFunctions.esUsuarioFinal();

        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.canView = true;
    
    this.buildForm();

    this.getConsorcios();
    this.getComunidades();
    this.getMonedas();
    this.getEstados();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
    

    this.setQueryParams();
    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });
  }

  buildForm() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);
   
    this.searchForm = this.formBuilder.group({
      'FechaExpensaDesde': [null],
      'FechaExpensaHasta': [null],
      'FechaVencimientoDesde': [null],
      'FechaVencimientoHasta': [null],
      'MonedaId': [null],
      'ConsorcioId': [cId],
      'ComunidadId': [null],
      'EstadoId': [null],
      'VerSoloActivos': [true]
    });

    if (!this.canEdit)
      this.searchForm.get("EstadoId")?.setValue(EstadoConstants.ESTADO_EXPENSA_PUBLICADA);
  }

  getMonedas() {
    var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(r).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedaList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getConsorcios() {
    // if (!this.tenantFeatureFlags?.HabilitarGestionConsorcio)
    //   return;
  
    var r = new SearchConsorcioRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isConsorcioSearching = true;
  
    this.consorcioService.search(r).subscribe(data => {
      this.isConsorcioSearching = false;
      this.consorcioList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isConsorcioSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getEstados() {
    var r = new SearchEstadoRequest(null, null, true, "Nombre", null, null, true);
    this.isEstadoSearching = true;

    this.estadoService.searchExpensaEstados(r).subscribe(data => {
      this.isEstadoSearching = false;
      this.estadoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isEstadoSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getComunidades() {
    var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
    if (cId != null && cId.length > 0 && cId > 0)
      cId = Number(cId);

    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
    this.isComunidadSearching = true; 

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      if (data != null)
        this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false; 
      this.sharedFunctions.handleError(err);
    });
  }

  clearDate(formFieldName: string) {
    if (formFieldName != null && formFieldName.length > 0) {
      if (this.searchForm.get(formFieldName) != null && this.searchForm.get(formFieldName)?.value)
        this.searchForm.get(formFieldName)?.setValue(null);
    }
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "MonedaId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.MonedaId;
    else
      this.query.addParams("MonedaId",this.searchForm.value.MonedaId);
    
    index = this.query.params.findIndex(obj => obj.key === "ConsorcioId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ConsorcioId;
    else
      this.query.addParams("ConsorcioId",this.searchForm.value.ConsorcioId);

    index = this.query.params.findIndex(obj => obj.key === "ComunidadId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ComunidadId;
    else
      this.query.addParams("ComunidadId",this.searchForm.value.ComunidadId);

    index = this.query.params.findIndex(obj => obj.key === "EstadoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.EstadoId;
    else
      this.query.addParams("EstadoId",this.searchForm.value.EstadoId);

    index = this.query.params.findIndex(obj => obj.key === "FechaExpensaDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaExpensaDesde,"yyyy-MM-dd");
    else
      this.query.addParams("FechaExpensaDesde", this.datePipe.transform(this.searchForm.value.FechaExpensaDesde,"yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaExpensaHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaExpensaHasta,"yyyy-MM-dd");
    else
      this.query.addParams("FechaExpensaHasta", this.datePipe.transform(this.searchForm.value.FechaExpensaHasta,"yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoDesde");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde,"yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoDesde", this.datePipe.transform(this.searchForm.value.FechaVencimientoDesde,"yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "FechaVencimientoHasta");
    if (index >= 0)
      this.query.params[index].value = this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta,"yyyy-MM-dd");
    else
      this.query.addParams("FechaVencimientoHasta", this.datePipe.transform(this.searchForm.value.FechaVencimientoHasta,"yyyy-MM-dd"));

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.VerSoloActivos;
    else
      this.query.addParams("VerSoloActivos", this.searchForm.value.VerSoloActivos);
  }

  add() {
    if (this.canEdit)
      this.router.navigate(['expensa-liquidacion']);
    else
      this.sharedFunctions.showMessage("No tiene permisos para realizar esta operación", "Error");
  }

  config() {
    if (this.canConfig)
      this.router.navigate(['expensa-configuracion']);
    else
      this.sharedFunctions.showMessage("No tiene permisos para realizar esta operación", "Error");
  }

  edit(item: ExpensaDto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }
    
    this.router.navigate(['expensa-edit', item.Id]);
  }

  onExport() {
    var search = new SearchExpensaRequestDto(null, null, null, "", null, null, null, null, null, null, null);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "Expensas_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
